import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';

import { AuthContext } from '../../../auth-context';
import AgreementContainer from './agreement-container';
import { useDocument } from '../../../hooks/useDocument';
import { USER_TYPES, allowedUserType } from '../../../utils/constants';

const { PHARMACIST, SUPPLIER } = USER_TYPES;

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

const AgreementBanner = () => {
  const { user, userType } = useContext(AuthContext);
  const [userData, hasLoaded] = useDocument(`patients/${user?.uid}`);

  const hasNoPaymentAgreement = hasLoaded && !userData.acceptedAgreements?.payment && userType === PHARMACIST;
  const hasNoEulaAgreement =
    hasLoaded && !userData.acceptedAgreements?.eula && allowedUserType([PHARMACIST, SUPPLIER], userType);

  return (
    <Root>
      <Typography variant="body1" mb={2}>
        Action Required: Our agreements have been updated. You have an outstanding agreement that needs completing.
      </Typography>
      <Box display="flex" gap="2px">
        {hasNoPaymentAgreement && <AgreementContainer agreementRef="pharmacy_payment" />}
        {hasNoEulaAgreement && (
          <AgreementContainer agreementRef={userType === PHARMACIST ? 'pharmacy_eula' : 'supplier_eula'} />
        )}
        {!hasLoaded && <CircularProgress />}
      </Box>
    </Root>
  );
};

export default AgreementBanner;
